<template>
  <base-dialog @cancel="cancelDialog">
    <div slot="header">{{ params.type === 'create' ? $t('scope.text_539') : $t('scope.text_634') }}</div>
    <div slot="body">
      <a-form
        :form="form.fc">
        <a-form-item :label="$t('scope.text_763')" v-bind="formItemLayout">
          <a-input v-decorator="decorators.title" :placeholder="$t('scope.text_764')" />
        </a-form-item>
        <a-form-item :label="$t('scope.text_746')" v-bind="formItemLayout">
          <a-radio-group v-decorator="decorators.invoice_type" :options="invoiceTypeOptions" />
        </a-form-item>
        <a-form-item :label="$t('scope.text_765')" v-bind="formItemLayout">
          <a-input v-decorator="decorators.register_no" :placeholder="$t('scope.text_766')" />
        </a-form-item>
        <a-form-item :label="$t('scope.text_767')" v-bind="formItemLayout">
          <a-input v-decorator="decorators.bank_name" :placeholder="$t('scope.text_768')" />
        </a-form-item>
        <a-form-item :label="$t('scope.text_769')" v-bind="formItemLayout">
          <a-input v-decorator="decorators.bank_account" :placeholder="$t('scope.text_770')" />
        </a-form-item>
        <a-form-item :label="$t('scope.text_771')" v-bind="formItemLayout">
          <a-input v-decorator="decorators.address" :placeholder="$t('scope.text_772')" />
        </a-form-item>
        <a-form-item :label="$t('scope.text_773')" v-bind="formItemLayout">
          <a-input v-decorator="decorators.phone" :placeholder="$t('scope.text_774')" />
        </a-form-item>
        <a-form-item :label="$t('scope.text_775')" v-bind="formItemLayout">
          <a-switch checked-:children="$t('scope.text_699')" un-checked-:children="$t('scope.text_700')" v-decorator="decorators.is_default" />
        </a-form-item>
      </a-form>
    </div>
    <div slot="footer">
      <a-button type="primary" @click="handleConfirm" :loading="loading">{{ $t('dialog.ok') }}</a-button>
      <a-button @click="cancelDialog">{{ $t('dialog.cancel') }}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'

export default {
  name: 'AddInvoiceInfoDialog',
  mixins: [DialogMixin, WindowsMixin],
  data () {
    return {
      loading: false,
      form: {
        fc: this.$form.createForm(this),
      },
      formItemLayout: {
        wrapperCol: {
          span: 20,
        },
        labelCol: {
          span: 4,
        },
      },
      decorators: {
        title: [
          'title',
          {
            initialValue: this.params.type === 'edit' ? this.params.data[0].title : '',
            rules: [
              { required: true, message: this.$t('scope.text_764') },
            ],
          },
        ],
        invoice_type: [
          'invoice_type',
          {
            initialValue: this.params.type === 'edit' ? this.params.data[0].invoice_type : 'ordinary',
            rules: [
              { required: true, message: this.$t('scope.text_776') },
            ],
          },
        ],
        register_no: [
          'register_no',
          {
            initialValue: this.params.type === 'edit' ? this.params.data[0].register_no : '',
            rules: [
              { required: true, message: this.$t('scope.text_766') },
            ],
          },
        ],
        bank_name: [
          'bank_name',
          {
            initialValue: this.params.type === 'edit' ? this.params.data[0].bank_name : '',
            rules: [
              { required: true, message: this.$t('scope.text_768') },
            ],
          },
        ],
        bank_account: [
          'bank_account',
          {
            initialValue: this.params.type === 'edit' ? this.params.data[0].bank_account : '',
            rules: [
              { required: true, message: this.$t('scope.text_770') },
            ],
          },
        ],
        address: [
          'address',
          {
            initialValue: this.params.type === 'edit' ? this.params.data[0].address : '',
            rules: [
              { required: true, message: this.$t('scope.text_772') },
            ],
          },
        ],
        phone: [
          'phone',
          {
            initialValue: this.params.type === 'edit' ? this.params.data[0].phone : '',
            rules: [
              { required: true, message: this.$t('scope.text_774') },
            ],
          },
        ],
        is_default: [
          'is_default',
          {
            initialValue: this.params.type === 'edit' ? this.params.data[0].is_default : false,
            valuePropName: 'checked',
          },
        ],
      },
      invoiceTypeOptions: [
        { label: this.$t('scope.text_721'), value: 'ordinary' },
        { label: this.$t('scope.text_722'), value: 'special' },
        { label: this.$t('scope.text_723'), value: 'ngo' },
      ],
    }
  },
  methods: {
    doCreate (data) {
      return this.params.onManager('create', {
        managerArgs: {
          data,
        },
      })
    },
    doEdit (data) {
      return this.params.onManager('update', {
        id: this.params.data[0].id,
        managerArgs: {
          data,
        },
      })
    },
    async handleConfirm () {
      this.loading = true
      try {
        const values = await this.form.fc.validateFields()
        const data = {
          ...values,
          name: 'commonlyused',
        }
        if (this.params.type === 'create') {
          await this.doCreate(data)
        } else {
          await this.doEdit(data)
        }
        this.loading = false
        this.cancelDialog()
        this.params.refresh()
      } catch (error) {
        this.loading = false
      }
    },
  },
}
</script>
